/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_user$ref = any;
export type PdpRespSimilarItemsGridSeller_user$ref = any;
export type PdpRespSimilarItemsGridSeller_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": PdpRespSimilarItem_user$ref;
    readonly " $refType": PdpRespSimilarItemsGridSeller_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsGridSeller_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItem_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '5b2e65f31db68091b30628f9f595bb50';
export default node;
